module.exports = __webpack_public_path__ + "img/3.8fd2fcb1.png";